/**
 * Pure model of the comic reader: which image to show at each step. On wide screens every
 * page is shown whole; on narrow screens a double spread is read in two halves, so the
 * panels stay large enough to read on a phone.
 */

export interface ComicPage {
  src: string;
  /** True for a double-page spread (twice as wide as a single page). */
  spread: boolean;
}

export type ReaderMode = 'wide' | 'narrow';

export interface ReaderStep {
  src: string;
  /** Index of the original page this step belongs to. */
  page: number;
  half: 'left' | 'right' | null;
}

export function buildSteps(pages: ComicPage[], mode: ReaderMode): ReaderStep[] {
  return pages.flatMap((p, page): ReaderStep[] =>
    mode === 'narrow' && p.spread
      ? [
          { src: p.src, page, half: 'left' },
          { src: p.src, page, half: 'right' },
        ]
      : [{ src: p.src, page, half: null }]
  );
}

/** The first step that shows a given original page. */
export function stepForPage(steps: ReaderStep[], page: number): number {
  const i = steps.findIndex((s) => s.page === page);
  return i < 0 ? 0 : i;
}
